import { render } from "./AddDomainModal.vue?vue&type=template&id=98519686"
import script from "./AddDomainModal.vue?vue&type=script&lang=js"
export * from "./AddDomainModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__